module.exports = __webpack_public_path__ + "2cd0d7d67bffa9fc8c52a1aab23f98fe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/zombie-stitches-s.png
// module id = 1960
// module chunks = 0